'use client';

// biome-ignore lint/style/noRestrictedImports: Used to create our custom Link component
import { default as NextLink } from 'next/link';
import { forwardRef } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';
import { getPageViewDataLayerObject, type TrackEventParams, trackEvent } from '@/app_lib/services/Gtm/utils';
import { cn } from '@/app_lib/utils/utils';

// TODO: What should the default link behavior be (i.e. hover, visited, focused, etc.)
// TODO: How should navbar links be defined vs. in-content links?
const link = tv({
  variants: {
    variant: {
      primary: 'text-blue-500 dark:text-blue-300 text-primary-hover text-primary-pressed text-primary-visited',
      secondary: 'text-red-500 dark:text-red-400 hover:underline',
    },
  },
});

type LinkVariants = VariantProps<typeof link>;

export interface LinkProps extends LinkVariants, React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  className?: string;
  prefetch?: boolean;
  children: React.ReactNode;
  trackingData?: TrackEventParams;
}

/** Use this for all internal navigation. */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, className, prefetch = true, children, variant, onClick, trackingData, ...rest }, ref) => (
    <NextLink
      className={cn(className, link({ variant }))}
      href={encodeURI(href)}
      onClick={(e) => {
        // TODO: check with data team to see if we can track failures
        if (trackingData) {
          const pageData = getPageViewDataLayerObject();
          trackEvent({ ...pageData, ...trackingData.data }, trackingData.eventType);
        }
        onClick?.(e);
      }}
      prefetch={prefetch}
      ref={ref}
      {...rest}
    >
      {children}
    </NextLink>
  ),
);
